import React from 'react';
import DynamicTable from '@atlaskit/dynamic-table';
import { Box, Stack, Text } from '@atlaskit/primitives';
import { FormattedMessage } from '@atlassian/jira-intl';
import type { IntegrationsState } from '../../../../services/store/integrations/types.tsx';
import { messages } from './messages.tsx';

export const SyncedIntegrationsTable = ({
	syncedIntegrations,
}: {
	syncedIntegrations: IntegrationsState['syncedIntegrations'];
}) => {
	if (!syncedIntegrations.data) {
		throw new Error(
			'SyncedIntegrationsTable should be rendered when synced integrations are loaded',
		);
	}

	const rows = syncedIntegrations.data.values.map((item, index) => ({
		key: `row-${index}`,
		cells: [
			{
				key: `cell-${index}-sync-integration`,
				content: (
					<Box paddingInlineStart="space.100" paddingBlock="space.100">
						<Text as="p" maxLines={1}>
							{item.integrationName}
						</Text>
					</Box>
				),
			},
			{
				key: `cell-${index}-team-name`,
				content: (
					<Box paddingInlineStart="space.100" paddingBlock="space.100">
						<Text as="p" maxLines={1}>
							{item.teamName}
						</Text>
					</Box>
				),
			},
		],
	}));

	const head = {
		cells: [
			{
				key: 'sync-integration',
				content: (
					<Box paddingInlineStart="space.100">
						<FormattedMessage {...messages.syncedIntegrationsTableIntegrationNameHeadNonFinal} />
					</Box>
				),
				isSortable: true,
			},
			{
				key: 'team-name',
				content: (
					<Box paddingInlineStart="space.100">
						<FormattedMessage {...messages.syncedIntegrationsTableTeamNameHeadNonFinal} />
					</Box>
				),
			},
		],
	};

	return (
		<Stack space="space.100">
			<Text color="color.text.subtlest">
				<FormattedMessage
					{...messages.syncedIntegrationCountNonFinal}
					values={{
						count: syncedIntegrations.data.count,
					}}
				/>
			</Text>
			<DynamicTable
				isLoading={syncedIntegrations.loading}
				isFixedSize
				head={head}
				rows={rows}
				rowsPerPage={5}
				defaultPage={1}
			/>
		</Stack>
	);
};
